var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("input-checkbox", {
    attrs: {
      label: _vm.$t("SHARE.PLAYTIME", {
        playtime: _vm.toHumanTime(_vm.playtime)
      }),
      value: _vm.content === "time",
      color: _vm.color,
      "border-color": _vm.color,
      background: _vm.background,
      "data-test": "tab-share--playtime"
    },
    on: { change: _vm.toggleContent }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }